import * as yup from 'yup';

import { extractDigits } from 'lib/phone';

export function referToFormValidation() {
  return yup.object().shape({
    providerType: yup
      .object()
      .shape({
        apiName: yup.string(),
        displayName: yup.string(),
      })
      .nullable()
      .test('providerType', 'Provider type is required', (obj) => Boolean(obj?.apiName)),
    group: yup
      .object()
      .shape({
        id: yup.string(),
        name: yup.string(),
      })
      .nullable()
      .test('group', 'Group is required', (obj) => Boolean(obj?.id)),
    note: yup.object().shape({
      attachments: yup.array(),
      text: yup.string(),
    }),
  });
}

export function referralDeterminantsFormValidation() {
  return yup.object().shape({
    phone: yup
      .string()
      .nullable()
      .test('phone', 'Phone number must be 10 digits', (value) => {
        const digits = extractDigits(value);
        return digits.length === 10 || digits.length === 0;
      }),
    expectedDischargeDate: yup.date().nullable(),
    address1: yup.string().nullable(),
    address2: yup.string().nullable(),
    city: yup.string().nullable(),
    state: yup.string().nullable(),
    zip: yup
      .string()
      .nullable()
      .test('zip', 'Zip code must be 5 digits', (value) => {
        if (!value) return true;

        const digits = extractDigits(value);

        return digits.length === value?.length && (digits.length === 5 || digits.length === 0);
      }),
  });
}

export function referralFormValidation() {
  return referToFormValidation().concat(referralDeterminantsFormValidation());
}
